const settingsMinimumLevel = 4;

export function canAccessSettings(level?: number): boolean {
  return (level ?? 0) >= settingsMinimumLevel;
}
